module.exports = "/assets/packs/images/bf7077775371c95b06b53beac08ca9de.svg";